import { FC } from 'react'
import { SvgProps } from './svgProps'

const RattingMaterialIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0026 0.5L19.5 7.81741L17.0785 9.76357L19.476 11.7635L9.99761 19.5L0.524083 11.6487L2.92167 9.67881L0.5 7.70219L10.0026 0.5ZM3.73705 10.3443L2.14523 11.6522L10.0025 18.164L17.8549 11.7547L16.2582 10.4228L9.99759 15.4544L3.73705 10.3443ZM2.16931 7.73271L10.0025 14.1263L17.8309 7.8348L9.99754 1.79952L2.16931 7.73271Z"
      fill={color || '#000'}
    />
  </svg>
)

export default RattingMaterialIcon
